<template>
    <div name="patient-info">
        <steps :step=1 />
        <div class="contain">
            <div>
                <text-label 
                    :text="'이름(진료 받으실 분)'"
                    :isDefault="true"
                />
                <input v-model="profile.name" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8)"
                    ref="name"
                    class="input-big"
                    placeholder="이름을 적어주세요"
                />
            </div>
            <div style="margin-top: 20px;">
                <text-label 
                    :text="'주민등록번호'"
                    :isDefault="true"
                />
                <div style="margin-bottom: 8px;display: flex;align-items: center;">
                    <input v-model="registrationNumber1" inputmode="numeric" 
                        v-focus-background
                        class="input-medium"
                        placeholder="주민번호 앞자리"
                        maxlength="6"
                        ref="registrationNumber1"
                    /> <span style="margin-right: 7px;">-</span> 
                    <input type="password" v-model="registrationNumber2" inputmode="numeric" 
                        v-focus-background
                        class="input-medium"
                        placeholder="주민번호 뒷자리"
                        maxlength="7"
                        ref="registrationNumber2"
                    />
                </div>    
                <div class="row">
                    <span class="info-text">병원에서 <span class="info-color-text">진료와 처방전 발행</span>에 필요해요</span>
                </div>       

            </div>
            <div class="direction-column" style="margin-top: 20px;">
                <text-label 
                    :text="'연락처'"
                    :isDefault="true"
                />
                <input 
                    v-model="phone_number"
                    inputmode="numeric"
                    v-focus-background
                    class="input-big"
                    style="margin-bottom: 8px;"
                    placeholder="진료 받으실 분의 연락처를 적어주세요"
                    ref="phone"
                />
                <div class="row">
                    <span class="info-text">진료 시간이 되면 <span class="info-color-text">의사가 전화로 연락</span>드려요</span>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <text-label 
                    :text="'키 & 몸무게'"
                    :isDefault="false"
                />
                <input 
                    v-model="profile.height"
                    v-focus-background
                    class="input-small"
                    placeholder="161"
                    ref="height"
                    inputmode="numeric"
                /> <span class="unit-text">cm</span>
            
                <input 
                    v-model="profile.weight"
                    v-focus-background
                    class="input-small"
                    placeholder="59"
                    ref="weight"
                    inputmode="numeric"
                /> <span class="unit-text">kg</span>
            </div>
            <div class="direction-column" style="margin-top: 20px;">
                <!-- <text-label 
                    :text="'기저질환'"
                    :isDefault="false"
                />
                <input 
                    v-model="profile.underlying_disease"
                    v-focus-background
                    class="input-big"
                    placeholder="예: 고혈압, 25년 01월 01일 오후 3시 진료희망"
                    style="margin-bottom: 8px;"
                /> -->
                <text-label 
                    :text="'희망 예약 날짜 및 시간'"
                    :isDefault="false"
                />
                <input 
                    v-model="date"
                    v-focus-background
                    class="input-big"
                    placeholder="예: 고혈압, 25년 01월 01일 오후 3시 진료희망"
                    style="margin-bottom: 8px;"
                    type="date"
                    ref="date"
                />
                <input 
                    v-model="time"
                    v-focus-background
                    class="input-big"
                    placeholder="예: 고혈압, 25년 01월 01일 오후 3시 진료희망"
                    style="margin-bottom: 8px;"
                    type="time"
                    ref="time"
                />
                <div class="row">
                    <!-- <span class="info-text">고혈압, 당뇨 등 <span class="info-color-text">평소 불편한 곳을 모두</span> 적어주세요</span> -->
                </div>
            </div>
        </div>
        <div class="agree-box">
            <div class="all-agree" ref="agree" >
                <check-box 
                    :checked="allAgree"
                    @onClick="allAgreeFunction"
                />
                <span @click="allAgreeFunction" class="all-agree-text">모두 동의합니다.</span>
            </div>
            <div v-if="agreeError" class="error-info-text">이용약관에 동의해 주세요</div>

            <div class="agree-detail-box" style="margin-top: 20px;">
                <div class="row">
                    <check-box 
                        :checked="agreement_terms_condition_description"
                        @onClick="() => {agreement_terms_condition_description = !agreement_terms_condition_description}"
                    />
                    <span class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 서비스 이용약관</span>
                </div>

                <img style="width: 20px;cursor: pointer;" @click="openPolicy(1)" src="../../../assets/detail.png" />
            </div>
            <div class="agree-detail-box" style="margin-top: 16px; margin-bottom: 40px">
                <div class="row">
                    <check-box 
                        :checked="agreement_personal_info"
                        @onClick="() => {agreement_personal_info = !agreement_personal_info}"
                    />
                    <span class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 개인정보 수집 및 이용</span>
                </div>
                <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../../../assets/detail.png" />
            </div>

            <bottom-button 
                :text="'다음 단계'"
                :color="'var(--Gray-100, #1E1E1E)'"
                @onClick="nextStep"
            />
        </div>
    </div>
</template>

<script>
import Steps from '@/components/molecules/sleepq/Steps';
import BottomButton from '@/components/atoms/BottomButton';
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import focusBackground from '@/components/directives/focusBackground';
import CheckBox from '@/components/atoms/CheckBox';
import Convert from '@/utilities/convert';

export default {
    name: 'patientInfo',
    computed: mapState(['profile', 'agreements']),
    components: {
        Steps,
        BottomButton,
        CheckBox,
        TextLabel
    },
    directives: {
        focusBackground
    },
    mounted: function()
    {
        this.topFunction();
    },  
    data: function()
    {
        return {
            registrationNumber1: '',
            registrationNumber2: '',
            phone_number: '',
            allAgree: false,
            agreeError: false,
            agreement_location_service: false,
            agreement_marketing: false,
            agreement_personal_info: false,
            agreement_terms_condition_description: false,
            date: null,
            time: null
        }
    },  
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },      
        moveToNext: function(event, nextField) {
            if (event.target.value.length === 6) {
                // this.$refs['registrationNumber1'].style.backgroundColor = 'var(--Gray-20, #F3F5F8)';
                this.$refs[nextField].focus();
            }
        },
        nextStep: function()
        {
            // validation 
            // 이름: (공백확인, 숫자가 없는지 확인)
            // 주민등록번호: 숫자만 입력가능하도록 (키패드 기능)
            // 연락처: 숫자만 이렵가능하도록 - 없이 (자리수 ~자리 이상 ~자리 이하), 특수기호 검증 
            // 키, 몸무게 (숫자만)
            // 필수 동의항목 

            if(this.profile.name == '' || Convert.containsNumber(this.profile.name))
            {
                this.errorFocus('name');
                return;
            }
            
            if(this.registrationNumber1.length !== 6)
            {
                this.errorFocus('registrationNumber1')
                return;
            }

            if(this.registrationNumber2.length !== 7)
            {
                this.errorFocus('registrationNumber2')
                return;
            }

            if(this.phone_number === '' || this.phone_number.length < 8)
            {
                this.errorFocus('phone')
                return;
            }

            if(this.profile.height != '')
            {
                if(!Convert.isNumeric(this.profile.height))
                {
                    this.errorFocus('height')
                    return;
                }
            }

            if(this.profile.weight != '')
            {
                if(!Convert.isNumeric(this.profile.weight))
                {
                    this.errorFocus('weight')
                    return;
                }
            }         
            
            if(this.date === null || this.date === undefined || this.date === '')
            {
                this.errorFocus('date')
                return;
            }
            if(this.time === null || this.time === undefined || this.time === '')
            {
                this.errorFocus('time')
                return;
            }

            
            if(!this.agreement_terms_condition_description || !this.agreement_personal_info || !this.agreement_location_service)
            {
                this.agreeError = true;
                return;
            }

            this.profile.underlying_disease = `${this.date} ${this.time}`;

            this.agreements.agreement_location_service = this.agreement_location_service;
            this.agreements.agreement_marketing = this.agreement_marketing;
            this.agreements.agreement_personal_info = this.agreement_personal_info;
            this.agreements.agreement_terms_condition_description = this.agreement_terms_condition_description;

            this.profile.phone_number = this.phoneFormat(this.phone_number);
            this.profile.registration_number = this.registrationNumber1 + this.registrationNumber2;


            this.$emit('nextStep', 1)
        },
        allAgreeFunction: function()
        {
            this.allAgree = !this.allAgree;
        },
        phoneFormat: function(target){

            // 특수문자 제거
            target = target.replace(/[^0-9]/g, "");
            console.log(target.slice(0, 3));

            if(target.length === 8)
            {
                const value = target.split("");
                const textArr = [
                    // 첫번째 구간 (00 or 000)
                    [0, 4],
                    // 두번째 구간 (000 or 0000)
                    [0, 4]
                ];

                // 총 3번의 반복 ({2,3}) - ({3,4}) - ({4})
                target = textArr
                    .map(function(v)  { 
                        return value.splice(v[0], v[1]).join("") 
                    })
                    .filter(function(text) { 
                        return text 
                    })
                    .join("-");

                return target;
            }
            else if(target.length > 8)
            {
                const compare = target.slice(0, 4);
                if(compare.includes("02") | compare.includes("032") | compare.includes("042") | compare.includes("051") | compare.includes("052")
                | compare.includes("053") | compare.includes("062") | compare.includes("064") | compare.includes("031") | compare.includes("033")
                | compare.includes("041") | compare.includes("043") | compare.includes("054") | compare.includes("055") | compare.includes("061")
                | compare.includes("063") | compare.includes("0504"))
                {
                    const value = target.split("");

                    if(compare.includes("02"))
                    {
                        const textArr = [
                            // 첫번째 구간 (00 or 000)
                            [0, 2],
                            // 두번째 구간 (000 or 0000)
                            [0, value.length > 9 ? 4 : 3],
                            // 남은 마지막 모든 숫자
                            [0, 4]
                        ];

                        // 총 3번의 반복 ({2,3}) - ({3,4}) - ({4})
                        target = textArr
                            .map(function(v)  { 
                                return value.splice(v[0], v[1]).join("") 
                            })
                            .filter(function(text) { 
                                return text 
                            })
                            .join("-");

                        return target;
                    }   
                    else if(compare.includes("0504"))
                    {
                        const textArr = [
                            // 첫번째 구간 (00 or 000)
                            [0, 4],
                            // 두번째 구간 (000 or 0000)
                            [0, value.length > 11 ? 4 : 3],
                            // 남은 마지막 모든 숫자
                            [0, 4]
                        ];

                        // 총 3번의 반복 ({2,3}) - ({3,4}) - ({4})
                        target = textArr
                            .map(function(v)  { 
                                return value.splice(v[0], v[1]).join("") 
                            })
                            .filter(function(text) { 
                                return text 
                            })
                            .join("-");

                        return target;
                    }
                    else
                    {
                        const textArr = [
                            // 첫번째 구간 (00 or 000)
                            [0, 3],
                            // 두번째 구간 (000 or 0000)
                            [0, value.length > 10 ? 4 : 3],
                            // 남은 마지막 모든 숫자
                            [0, 4]
                        ];

                        // 총 3번의 반복 ({2,3}) - ({3,4}) - ({4})
                        target = textArr
                            .map(function(v)  { 
                                return value.splice(v[0], v[1]).join("") 
                            })
                            .filter(function(text) { 
                                return text 
                            })
                            .join("-");

                        return target;
                    }
                    
                }
                else
                {
                    const value = target.split("");
                    const textArr = [
                        // 첫번째 구간 (00 or 000)
                        [0, value.length > 9 ? 3 : 2],
                        // 두번째 구간 (000 or 0000)
                        [0, value.length > 10 ? 4 : 3],
                        // 남은 마지막 모든 숫자
                        [0, 4]
                    ];

                    // 총 3번의 반복 ({2,3}) - ({3,4}) - ({4})
                    target = textArr
                        .map(function(v)  { 
                            return value.splice(v[0], v[1]).join("") 
                        })
                        .filter(function(text) { 
                            return text 
                        })
                        .join("-");

                    return target;
                }
            }
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/barocare/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/barocare/use", '_blank')
            }
            else if(index === 3)
            {
                window.open("https://policy.soldoc.co.kr/location", '_blank')
            }
            else if(index === 4)
            {
                window.open("https://policy.soldoc.co.kr/marketing", '_blank')
            }
        }
    },
    
    watch: {
        allAgree: function()
        {
            this.agreement_location_service = this.allAgree;
            this.agreement_marketing = this.allAgree;
            this.agreement_personal_info = this.allAgree;
            this.agreement_terms_condition_description = this.allAgree;
            this.agreeError = false;
        },
        registrationNumber1: function(newValue) {
            this.registrationNumber1 = newValue.replace(/[^0-9]/g, '');

        },
        registrationNumber2(newValue) {
            this.registrationNumber2 = newValue.replace(/[^0-9]/g, '');
        },
        phone_number(newValue) {
            this.phone_number = newValue.replace(/[^0-9]/g, '');
        },
        agreement_terms_condition_description: function()
        {
            this.agreeError = false;
        },
        agreement_personal_info: function()
        {
            this.agreeError = false;
        },
        agreement_location_service: function()
        {
            this.agreeError = false;
        }
         
    }
}
</script>

<style scoped>
    .contain {
        width: 100%;
        padding: 40px 16px;
        display: flex;
        flex-direction: column;
    }
    .input-big {
        width: calc(100% - 64px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .input-medium {
        width: calc(50% - 32px - 30px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
    }
    .input-small {
        width: calc(50% - 32px - 72px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
    }
    .direction-row {
        display: flex;
        flex-direction: row;
        width: 100%;
    }
    .direction-column {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .info-color-text {
        color: #184FA1;
    }
    .unit-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-right: 36px;
    }
    .agree-box {
        border-top: 8px solid var(--Gray-sub-color1, #F3F5F8);
        padding: 40px 16px 0 16px;
        width: calc(100% - 32px);
    }
    .all-agree {
        height: 60px;
        flex-shrink: 0;
        width: calc(100% - 16px);
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
    .agree-detail-box {
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 32px;
        width: calc(100% - 16px);

    }

    .all-agree-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 100% */
        cursor: pointer;
        margin-left: 17px;
    }
    .agree-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .row {
        display: flex;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/sleepq/PatientInfo.vue